// Temporarily hide assignee roles; keep their data and behavior ready to restore.
export const SHOW_TASK_ASSIGNEE_ROLES = false;
